module.exports = __webpack_public_path__ + "img/accessdoor.7d000adc.jpg";